import type { AllModelVersion, ModelVersion } from '@/app/types';
import { getReferenceImageAndElementMaxCount, getReferenceVideoElementMaxCount } from './reference-model-capabilities';

/**
 * 获取指定模型版本支持的最大图片+主体数量（不含视频）。
 *
 * 各版本的具体额度见 `reference-model-capabilities.ts` 的 capability table，
 * 不要在这里重复列数字 —— 抄一份就会漂移。
 * @deprecated 直接用 `getReferenceImageAndElementMaxCount`，这里只是旧调用点的兼容壳。
 */
export const getMaxImageAndElementCount = (modelVersion: AllModelVersion): number => {
  return getReferenceImageAndElementMaxCount(modelVersion);
};

/**
 * @deprecated 直接用 `getReferenceVideoElementMaxCount`，这里只是旧调用点的兼容壳。
 */
export const getMaxVideoElementCount = (modelVersion: ModelVersion): number => {
  return getReferenceVideoElementMaxCount(modelVersion);
};
